import React from 'react';

export default function GiftBox2({color}) {
  const commonProps = {
    fill: 'none',
    stroke: color,
    strokeWidth: 4.6053,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    strokeMiterlimit: 10,
  };

  return (
    <svg width='95' height='60' viewBox="0 0 215.13 142.76" xmlns="http://www.w3.org/2000/svg">
      <g>
        <rect x="59.87" y="64.81" width="95.39" height="59.21" {...commonProps} />
        <rect x="53.29" y="38.49" width="108.55" height="26.32" {...commonProps} />

        <polyline
          points="97.7,124.02 97.7,65.22 97.7,38.49 117.43,38.49 117.43,124.02"
          {...commonProps}
        />

        <path
          d="M98.57,38.49c-8.99,0-31.37-9.23-31.37-23.06c0-5.1,4.03-9.23,8.99-9.23c13.38,0,31.37,18.45,31.37,32.29"
          {...commonProps}
        />
        <path
          d="M116.56,38.49c8.99,0,31.37-9.23,31.37-23.06c0-5.1-4.03-9.23-8.99-9.23c-13.38,0-31.37,18.45-31.37,32.29"
          {...commonProps}
        />

        <line x1="179.93" y1="71.38" x2="199.67" y2="71.38" {...commonProps} />
        <line x1="206.25" y1="108.22" x2="179.93" y2="97.69" {...commonProps} />
        <line x1="179.93" y1="45.06" x2="212.83" y2="31.91" {...commonProps} />
        <line x1="189.8" y1="140.45" x2="173.36" y2="124.01" {...commonProps} />
        <line x1="173.36" y1="18.75" x2="186.51" y2="5.59" {...commonProps} />
        <line x1="35.2" y1="71.38" x2="15.46" y2="71.38" {...commonProps} />
        <line x1="8.88" y1="34.54" x2="35.2" y2="45.07" {...commonProps} />
        <line x1="35.2" y1="97.69" x2="2.3" y2="110.85" {...commonProps} />
        <line x1="25.33" y1="2.3" x2="41.78" y2="18.75" {...commonProps} />
        <line x1="41.78" y1="124.01" x2="28.62" y2="137.17" {...commonProps} />
      </g>
    </svg>
  );
}
